import { liftCategoriesToWaterfallChartProps } from '@features/campaigns';
import {
  ImageProps,
  Slide,
  chartOptionsToBase64Svg,
} from '@features/powerpoint';
import { Lci3SalesMetrics } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { contentSlideHeader } from '@features/lci-report/utils';
import { Metric } from './chart';
import { DEFINITIONS } from './definitions';
import { formatKeyTakeawaysText } from '@features/lci-report/slides/sales-attribution/key-takeaways-text';
import { waterfallChartOptions } from '@features/campaigns';

type ContributionMetricsSummarySlideProps = {
  slideMaster: string;
  overallSalesMetrics: Lci3SalesMetrics;
  metric: Metric;
  title: string;
  keyTakeaways: string;
};

const createDefinitionText = (
  title: string,
  definition: string,
  y: number
) => ({
  text: [{ text: `${title}: `, options: { bold: true } }, { text: definition }],
  options: { h: 0.41, w: 5.82, x: 0.73, y, fontSize: 8 },
});

export const contributionMetricsSummarySlide = (
  props: ContributionMetricsSummarySlideProps
): Slide => {
  const contributionMetricsGraph = chartOptionsToBase64Svg({
    chartOptions: waterfallChartOptions(
      liftCategoriesToWaterfallChartProps(
        props.metric,
        props.overallSalesMetrics
      )
    ),
    width: 600,
    height: 430,
  });

  const images: ImageProps[] = [
    {
      data: contributionMetricsGraph,
      h: 4,
      w: 6,
      x: 0.55,
      y: 1.64,
    },
  ];

  const definitionTexts = DEFINITIONS.map(({ title, definition, y }) =>
    createDefinitionText(title, definition, y)
  );

  return {
    slideMaster: props.slideMaster,
    texts: [
      contentSlideHeader(`Contribution Metrics - ${props.title}`),
      ...definitionTexts,
      ...formatKeyTakeawaysText(props.keyTakeaways),
    ],
    images,
  };
};
